import type { FeatureManifest } from '@/platform/navigation/featureManifest'

export const sentencePatternsManifest: FeatureManifest = {
  id: 'lessons-sentence-patterns',
  path: 'lessons/knowledge/sentence-patterns/*',
  navPath: '/lessons/knowledge/sentence-patterns',
  label: 'Mẫu câu',
  description: 'Kho cấu trúc câu dùng chung cho bài học',
  navigationGroup: { id: 'lessons', label: 'Bài học' },
  load: () => import('./entry'),
}
